module.exports = __webpack_public_path__ + "static/img/FigmaDDSSlicePNGaafcc2dd9fe23948b32fcc4fc87cf128.aafcc2dd.png";